import React from "react";

interface PlatformIconProps {
  platform: string;
  className?: string;
}

export const PlatformIcon: React.FC<PlatformIconProps> = ({
  platform,
  className = "w-4 h-4",
}) => {
  const key = (platform || "").toLowerCase();
  switch (key) {
    case "wildberries":
      return (
        <div className={`text-purple-600 ${className}`}>
          <svg viewBox="0 0 24 24" fill="currentColor">
            <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8z" />
            <path d="M12 6c-3.31 0-6 2.69-6 6s2.69 6 6 6 6-2.69 6-6-2.69-6-6-6zm0 10c-2.21 0-4-1.79-4-4s1.79-4 4-4 4 1.79 4 4-1.79 4-4 4z" />
            <circle cx="12" cy="12" r="2" />
          </svg>
        </div>
      );
    case "ozon":
      return (
        <div className={`text-blue-700 ${className}`}>
          <svg viewBox="0 0 24 24" fill="currentColor">
            <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-2 15l-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8l-9 9z" />
          </svg>
        </div>
      );
    case "yandex":
      return (
        <div className={`${className}`}>
          <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
            {/* Background */}
            <circle cx="12" cy="12" r="11" fill="#FFCC00" />
            {/* Stylized Y letter */}
            <path
              d="M7 7h2.4l2.1 3.6L13.6 7H16l-3.2 5.1V17H10.7v-4.9L7 7z"
              fill="#000000"
            />
          </svg>
        </div>
      );
    default:
      return (
        <div className={`text-gray-600 ${className}`}>
          <svg viewBox="0 0 24 24" fill="currentColor">
            <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-1 17.93c-3.94-.49-7-3.85-7-7.93 0-.62.08-1.21.21-1.79L9 15v1c0 1.1.9 2 2 2v1.93zm6.9-2.54c-.26-.81-1-1.39-1.9-1.39h-1v-3c0-.55-.45-1-1-1H8v-2h2c.55 0 1-.45 1-1V7h2c1.1 0 2-.9 2-2v-.41c2.93 1.19 5 4.06 5 7.41 0 2.08-.8 3.97-2.1 5.39z" />
          </svg>
        </div>
      );
  }
};

export const WildberriesIcon: React.FC<{ className?: string }> = ({
  className,
}) => (
  <div className={`text-purple-600 ${className}`}>
    <svg viewBox="0 0 24 24" fill="currentColor">
      {/* Wildberries стилизованная иконка */}
      <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8z" />
      <path d="M12 6c-3.31 0-6 2.69-6 6s2.69 6 6 6 6-2.69 6-6-2.69-6-6-6zm0 10c-2.21 0-4-1.79-4-4s1.79-4 4-4 4 1.79 4 4-1.79 4-4 4z" />
      <circle cx="12" cy="12" r="2" />
    </svg>
  </div>
);

export const OzonIcon: React.FC<{ className?: string }> = ({ className }) => (
  <div className={`text-blue-700 ${className}`}>
    <svg viewBox="0 0 24 24" fill="currentColor">
      {/* Ozon стилизованная иконка */}
      <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-2 15l-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8l-9 9z" />
    </svg>
  </div>
);

export const AllPlatformsIcon: React.FC<{ className?: string }> = ({
  className,
}) => (
  <div className={`text-gray-600 ${className}`}>
    <svg viewBox="0 0 24 24" fill="currentColor">
      {/* Иконка для всех платформ */}
      <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-1 17.93c-3.94-.49-7-3.85-7-7.93 0-.62.08-1.21.21-1.79L9 15v1c0 1.1.9 2 2 2v1.93zm6.9-2.54c-.26-.81-1-1.39-1.9-1.39h-1v-3c0-.55-.45-1-1-1H8v-2h2c.55 0 1-.45 1-1V7h2c1.1 0 2-.9 2-2v-.41c2.93 1.19 5 4.06 5 7.41 0 2.08-.8 3.97-2.1 5.39z" />
    </svg>
  </div>
);
